import type { ReactNode } from "react";

/** Content that must reach assistive technology but not the visual layout. */
export function VisuallyHidden({ children }: { children: ReactNode }) {
  return <span className="srOnly">{children}</span>;
}
